import { AxiosInstanceProvider } from '../../../core/hooks';
import { L3ServicesHttpQuery } from '../../config';
import { L3ServiceApiModel } from '../../model';

export interface L3ServicesHttpGetPayloadModel {
  customerId: number;
}

export type L3ServicesHttpGetResponseModel = L3ServiceApiModel[];

export const getL3Services = async (axios: AxiosInstanceProvider, { customerId }: L3ServicesHttpGetPayloadModel): Promise<L3ServicesHttpGetResponseModel> => {
  const url = L3ServicesHttpQuery['GetL3Services'].url.replace('{customerId}', customerId.toString(10));
  const response = await axios().get<L3ServicesHttpGetResponseModel>(url);
  return response.data;
};